import { Button, Avatar as AntAvatar } from "antd";
import styled from "styled-components";

export const StyledButton = styled(Button)`
  background-color: #fdd440;
  color: #1070b6;
  :hover {
    background-color: #fce281;
    color: #1070b6;
  }
  :active,
  :focus {
    background-color: #fdd440;
    color: #1070b6;
  }
  border-width: 0;
  font-weight: bold;
  font-size: 16px;
  height: 36px;
  transform: scaleY(0.95);
  min-width: 130px;
  padding: 0px 20px;
`;

export const ReplacePhotoButton = styled(StyledButton)`
  background-color: #aac9e9;
  :hover {
    background-color: #96c0eb;
    color: #1070b6;
  }
  :active,
  :focus {
    background-color: #aac9e9;
    color: #1070b6;
  }
`;

export const UploadPhotoButton = styled(StyledButton)``;

export const VerticalCenterContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const Avatar = styled(AntAvatar)`
  background-color: #d3e8ff;
  svg {
    color: #7ea7d4;
  }
`;
